import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import toast from 'react-hot-toast';
import { CreateCoupon } from 'services/coupon/createCoupon';

const AddCouponDialog = ({ open, onClose }) => {
  const [code, setCode] = useState('');
  const [discountValue, setDiscountValue] = useState('');
  const [maxUses, setMaxUses] = useState('');
  const [expiresAt, setExpiresAt] = useState('');
  const [remark, setRemark] = useState('');

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const resetForm = () => {
    setCode('');
    setDiscountValue('');
    setMaxUses('');
    setExpiresAt('');
    setRemark('');
  };

  const { mutate, isLoading } = useMutation({
    mutationFn: CreateCoupon,
    onSuccess: (response) => {
      if (response.status) {
        toast.success('Coupon Created Successfully');
        resetForm();
        queryClient.invalidateQueries(['createCoupon']);
        if (onClose) onClose();
        navigate('/coupons');
      } else {
        toast.error('Unexpected response from server');
      }
    },
    onError: (error) => {
      toast.error('Failed to create coupon: ' + (error.message || 'Unknown error'));
      console.error('Failed to create coupon:', error);
    }
  });

  const handleCreateCoupon = () => {
    if (!code.trim() || !discountValue) {
      toast.error('Code and Discount Value are required.');
      return;
    }

    const newcoupon = {
      code: code.trim(),
      discountValue,
      maxUses,
      expiresAt,
      remark: remark.trim()
    };

    mutate(newcoupon);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Create Coupon</DialogTitle>
      <DialogContent>
        <TextField label="Code" fullWidth variant="outlined" margin="dense" value={code} onChange={(e) => setCode(e.target.value)} />
        <TextField
          label="Discount Value"
          type="number"
          fullWidth
          variant="outlined"
          margin="dense"
          value={discountValue}
          onChange={(e) => setDiscountValue(e.target.value)}
        />
        <TextField
          label="Max Uses"
          type="number"
          fullWidth
          variant="outlined"
          margin="dense"
          value={maxUses}
          onChange={(e) => setMaxUses(e.target.value)}
        />
        <TextField
          label="Expire Date"
          type="date"
          fullWidth
          variant="outlined"
          margin="dense"
          value={expiresAt}
          onChange={(e) => setExpiresAt(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField label="Remark" fullWidth variant="outlined" margin="dense" value={remark} onChange={(e) => setRemark(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleCreateCoupon} variant="contained" color="primary" disabled={isLoading}>
          {isLoading ? 'Creating...' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCouponDialog;
